import { ThemeProvider } from 'styled-components';
import GlobalStyle from './utils/GlobalStyle';
import theme from './utils/Theme';

import {
  BrowserRouter,
  Routes,
  Route,
} from "react-router-dom";

// header
import Header from './components/common/Header';
import routes from './utils/routes';
import Footer from './components/common/Footer';

const routeComponents = routes.map((route) => (
    <Route key={route.path} path={route.path} element={<route.component />} />
  ));

function App() {
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyle />
      <BrowserRouter>
        <Header />
        <Routes>
          {routeComponents}
        </Routes>
        <Footer />
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
